import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import * as THREE from 'three/build/three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import "three/examples/jsm/loaders/ColladaLoader";
import { HttpService } from '../../shared/services/http.service';
import { VRButton } from 'three/examples/jsm/webxr/VRButton';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader';
import { STLLoader } from 'three/examples/jsm/loaders/STLLoader';
import { Router } from '@angular/router';
import { Group, HemisphereLight, ImageLoader, Material, Mesh, Object3D, PointLight } from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { TGALoader } from 'three/examples/jsm/loaders/TGALoader';

@Component({
  selector: 'app-three-asset-render',
  templateUrl: './three-asset-render.component.html',
  styleUrls: ['./three-asset-render.component.css']
})
export class ThreeAssetRenderComponent implements OnInit {

  objectKeys = Object.keys;

  @ViewChild('rendererContainer') rendererContainer: ElementRef;
  @Input() filePath: string;
  @Input() seenBackGround;
  @Input() width: number;
  @Input() height: number;
  @Input() uploadedFiles: any;
  @Output() polygonCount: EventEmitter<number> = new EventEmitter<number>();
  @Input() rotateModel: boolean = false;
  @Output() loadAsset: EventEmitter<boolean> = new EventEmitter<boolean>();
  loader = false;
  isGalleryMode = false;
  renderer = new THREE.WebGLRenderer({ preserveDrawingBuffer: true, antialias: true });
  clock = new THREE.Clock();
  scene = null;
  camera = null;
  mesh = null;
  controls = null;
  uploadPercentDone = 0;
  uploadText = "Downloading";
  fullScreen = false;
  fullScreenModeCount = 1;
  VRObject: Object3D;
  cameraPosition: any;
  isVRModePresented = false;
  gui: any;
  mixer: any;
  lightHolder: any;
  matrix: any;
  constructor(private httpService: HttpService, private router: Router) {
    if (this.httpService.clear3DCache) {
      THREE.Cache.clear();
      this.httpService.clear3DCache = false;
    }
  }

  ngAfterViewInit() {
    // this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setSize(this.width - 40, this.height - 300)
    this.rendererContainer.nativeElement.appendChild(this.renderer.domElement);
    // VR Button
    this.rendererContainer.nativeElement.appendChild(VRButton.createButton(this.renderer));
    this.renderer.xr.enabled = true;
    this.cameraPosition = new THREE.Vector3().setFromMatrixPosition(this.camera.matrixWorld);
    this.renderer.xr.setReferenceSpaceType('local');

    this.renderer.shadowMap.enabled = true;
    this.renderer.outputEncoding = THREE.sRGBAEncoding;
    this.renderer.gammaFactor = 2.2;
    this.renderer.setClearColor(this.seenBackGround);
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.matrix = new THREE.Matrix4();
    this.matrix.makeRotationY(0.026);
    this.animate();


  }

  animate() {

    this.renderer.setAnimationLoop(() => this.animate());
    this.renderer.setClearColor(this.seenBackGround);
    this.lightHolder.quaternion.copy(this.camera.quaternion);
    this.controls.update();

    if (this.rotateModel === true && this.VRObject)
      {
        this.VRObject.applyMatrix4(this.matrix);
      }
      
    if (this.renderer.xr.isPresenting === true) {
      // Set the initial position of the 3D object wrt the VR camera
      if (!this.isVRModePresented) {
        this.isVRModePresented = true;
        this.VRObject.position.set(this.cameraPosition.x,-100,this.cameraPosition.z - 800);
      }
    }
    if (this.isVRModePresented && !this.renderer.xr.isPresenting) {
      this.camera.position.set(100, 200, 300);
      this.setModelPosition(this.VRObject);
      this.isVRModePresented = false;
    }
    if (this.mixer)
      this.mixer.update(this.clock.getDelta());

    this.renderer.render(this.scene, this.camera);
    this.polygonCount.emit(this.renderer.info.render.triangles);

    // let c: any = this.rendererContainer;
    // let ctx = c.getContext("2d");
    // let grd = ctx.createRadialGradient(window.innerHeight / 2, window.innerWidth / 2, window.innerHeight / 2 + 30, window.innerHeight, window.innerHeight, 100);
    // grd.addColorStop(0, "transparent");
    // grd.addColorStop(1, "black");

  }

  makeFullScreen() {
    let elem: any = document.querySelector('canvas');
    this.fullScreen = true;
    this.fullScreenModeCount = 0;
    elem.height = innerHeight;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) { /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) { /* IE/Edge */
      elem.msRequestFullscreen();
    }

  }

  closeCanvas() {
    this.loadAsset.emit(false);
  }
  // @HostListener('window:resize', ['$event'])
  // onWindowResize(event) {
  //     this.renderer.setSize(event.target.innerWidth, event.target.innerHeight)
  // }

  ngOnInit() {

    console.log(this.filePath);

    if (this.seenBackGround && this.seenBackGround.lenght > 0) {
      this.seenBackGround = 'black';
    }

    let url = this.router.url;
    if (url.indexOf('search') > 0) {
      this.isGalleryMode = true;
    }

    THREE.Cache.enabled = true;
    this.scene = new THREE.Scene();
    this.camera = new THREE.PerspectiveCamera(40, this.width / (this.height - 300), 1, 15000);

    this.camera.position.set(100, 200, 300);
    this.camera.rotation.order = 'YXZ';
    this.camera.rotation.y = - Math.PI / 4;
    this.camera.rotation.x = -Math.atan(- 1 / Math.sqrt(2));
    this.scene.add(this.camera);

    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.enabled = true;
    this.controls.enableDamping = true;
    this.controls.dampingFactor = 0.8;
    this.controls.enableZoom = true;


    // mesh
    this.mesh = new THREE.Mesh();

    // Light 
    const light = new HemisphereLight( 0xffffff, 0x444444, 1.0);
    light.position.set(0,200,0);
    this.scene.add(light);

    const pointLight = new PointLight(0xffffff,0.6);
    pointLight.position.set(0,200,100);
    pointLight.castShadow = true;
    this.scene.add(pointLight);

    //Set up shadow properties for the light
    pointLight.shadow.mapSize.width = 512;
    pointLight.shadow.mapSize.height = 512;
    pointLight.shadow.camera.near = 0.5;
    pointLight.shadow.camera.far = 500;

    this.lightHolder = new THREE.Group();
    this.lightHolder.add(pointLight);
    this.scene.add(this.lightHolder);

    // const light = new THREE.AmbientLightProbe(0x404040, 1);
    // this.scene.add(light);

    // const topLight = new THREE.DirectionalLight(0xFFFFFF, 0.5, 3000);
    // topLight.position.set(0, 250, 0);

    // const fillLight = new THREE.DirectionalLight(0xFFFFFF, 0.5, 3000);
    // fillLight.position.set(250, 0, 150);

    // const backLight = new THREE.DirectionalLight(0xFFFFFF, 0.5, 3000);
    // backLight.position.set(50, 50, 250);


    // const feedLight = new THREE.DirectionalLight(0xFFFFFF, 0.5, 3000);
    // feedLight.position.set(50, 0, -250);

    // const keyLight = new THREE.DirectionalLight(0xFFFFFF, 0.5, 3000);
    // keyLight.position.set(-250, 0, 0);

    // this.scene.add(topLight);
    // this.scene.add(fillLight);
    // this.scene.add(backLight);
    // this.scene.add(feedLight);
    // this.scene.add(keyLight);

    // this.gui = new GUI();
    // const params = {
    //   intensity: light.intensity
    // };
    // this.gui.add( params, 'intensity', 0, 8 ).onChange( function ( val ) {
    //   light.intensity = val;
    // } );
    // this.gui.open();

    let directoryArray = this.filePath.split("\\");
    let fileName = directoryArray[directoryArray.length - 1];
    let format = fileName.split('.')[1];
    
    if (format.toLocaleLowerCase() === 'fbx') {
      this.loader = true;
      var path = this.filePath.split("\\").slice(0, this.filePath.split("\\").length - 1).join('\\');

      const loadingManager = new THREE.LoadingManager();

      loadingManager.setURLModifier(function (url) {
        if (url.indexOf(path) <= -1) {
          url = `assets/${path}/${url.split('/')[url.split('/').length - 1]}`
        }
        return url;
      });
      loadingManager.addHandler( /\.tga$/i, new TGALoader() );
      loadingManager.addHandler( /\.jpg$/i, new ImageLoader() );
      loadingManager.addHandler( /\.jpeg$/i, new ImageLoader() );
      loadingManager.addHandler( /\.png$/i, new ImageLoader() );
      let loader = new FBXLoader(loadingManager);

      let threeDObj = THREE.Cache.get(this.filePath);
      if (!threeDObj) {
        if (this.httpService.previewDuringUpload) {
          if (this.uploadedFiles.length !== 0) {
            try {
              let threeDFileFromUpload = this.uploadedFiles[0];
              let reader = new FileReader();
              reader.onload = () => {
                // this 'text' is the content of the file

                var text = reader.result;
                console.log("File Read");
                try {
                  let threedObject = loader.parse(text, path);


                  threedObject.traverse(item => {
                    for (var i = 0; i < item.children.length; i++) {
                      this.applyDoubleSideProperty(item.children[i]);
                    }
                    // if(item.hasOwnProperty("material"))
                    // {
                    //   item.material.side = THREE.DoubleSide;
                    //   if(item.material.length > 1 && item.name !="pp01")
                    //   {
                    //     let material = this.getUniqueMaterials(item.material);
                    //     if(material != null)//has a duplicate material which may cause rendering issue
                    //       item.material = material;
                    //   }
                    // }

                    this.mixer = new THREE.AnimationMixer(threedObject);
                    const clips = threedObject.animations;
                    clips.forEach(clip => {
                      this.mixer.clipAction(clip.optimize()).play();
                    });


                  });
                  this.setModelPosition(threedObject);
                  this.VRObject = threedObject;
                  this.scene.add(threedObject);
                  this.loader = false;
                } catch (exception) {
                  console.log(exception);
                  alert("Unable to preview the asset");
                }
              }
              reader.readAsArrayBuffer(threeDFileFromUpload);
            } catch (err) {
              this.loader = false;
            }

          }
        }
        else {
          loader.load(`assets/${this.filePath}`, (object3d) => {
            THREE.Cache.clear();
            THREE.Cache.add(this.filePath, object3d);
            object3d.traverse((item) => {
              for (var i = 0; i < item.children.length; i++) {
                this.applyDoubleSideProperty(item.children[i]);
              }
            });
            this.mixer = new THREE.AnimationMixer(object3d);
            const clips = object3d.animations;

            clips.forEach(clip => {
              this.mixer.clipAction(clip.optimize() as any).play();
            });
            
            object3d.castShadow = true;
            this.setModelPosition(object3d);
            THREE.Cache.clear();
            THREE.Cache.add(this.filePath, object3d);
            this.VRObject = object3d;
            this.scene.add(object3d);
            console.log("Loaded");
            this.loader = false;
          }, (process) => {
            this.uploadPercentDone = Math.round((process.loaded / process.total * 100));
            if (this.uploadPercentDone >= 95) {
              this.uploadText = "Rendering"
            }
            console.log(this.uploadPercentDone + '% loaded');
          }, (err) => {
            console.error(err);
            this.loader = false;
          });
        }

      } else {
        this.VRObject = threeDObj;
        this.scene.add(threeDObj);
        this.loader = false;
      }
    } else if (format === "obj") {

      ///////////////////////MtlLoaderWithOBJ///////////////////////////////////////


      const manager = new THREE.LoadingManager();
      manager.addHandler(/\.tga$/i, new TGALoader());
      let mtlLoader = new MTLLoader(manager);

      directoryArray.splice(directoryArray.length - 1, 1);
      console.log(directoryArray.join('\\'));

      mtlLoader.setPath(`assets\\${directoryArray.join('\\')}\\`);

      this.loader = true;

      mtlLoader.load(`${fileName.split('.')[0]}.mtl`, (materials) => {

        materials.preload();

        var objLoader: any = new OBJLoader();
        objLoader.setMaterials(materials);
        objLoader.setPath(`assets\\${directoryArray.join('\\')}\\`);

        let threeDObj = THREE.Cache.get(this.filePath);

        if (!threeDObj) {
          if (this.httpService.previewDuringUpload) {
            if (this.uploadedFiles.length !== 0) {
              let threeDFileFromUpload = this.uploadedFiles[0];
              let reader = new FileReader();
              reader.onload = () => {
                // this 'text' is the content of the file
                var text = reader.result;
                console.log("File Read");

                let threedObject = objLoader.parse(text);
                THREE.Cache.clear();
                THREE.Cache.add(this.filePath, threedObject);

                this.setModelPosition(threedObject);
                this.VRObject = threedObject;
                this.scene.add(threedObject);

                this.loader = false;
              }
              reader.readAsText(threeDFileFromUpload);
            }
          }
          else {
            objLoader.load(fileName, (object) => {
              THREE.Cache.clear();
              THREE.Cache.add(this.filePath, object);

              this.VRObject = object;
              this.setModelPosition(object);
              this.scene.add(object);
              this.loader = false;
            }, (process) => {
              this.uploadPercentDone = Math.round((process.loaded / process.total * 100));
              if (this.uploadPercentDone >= 95) {
                this.uploadText = "Rendering"
              }
              console.log(this.uploadPercentDone + '% loaded');
            }, (err) => {
              console.log(err);
              this.loader = false;
            });
          }

        } else {
          this.VRObject = threeDObj;
          this.scene.add(threeDObj);
          this.loader = false;
        }
      }, (process) => {
        this.uploadPercentDone = Math.round((process.loaded / process.total * 100));
        if (this.uploadPercentDone >= 95) {
          this.uploadText = "Rendering"
        }
        console.log(this.uploadPercentDone + '% loaded');
        this.loader = false;
      });
    } else if (format === "stl") {
      let threeDObj = THREE.Cache.get(this.filePath);
      if (!threeDObj) {
        let loader = new STLLoader();
        this.loader = true;
        if (this.httpService.previewDuringUpload) {

          let threeDFileFromUpload = this.uploadedFiles[0];
          let reader = new FileReader();
          reader.onload = () => {
            // this 'text' is the content of the file
            var text = reader.result;
            console.log("File Read");

            let threedObject = loader.parse(text);
            setTimeout(() => {
              console.log("File Parsed");
            }, 100)
            let material = new THREE.MeshStandardMaterial();   
            let mesh = new THREE.Mesh(threedObject, material);

            this.setModelPosition(mesh);
            THREE.Cache.clear();
            THREE.Cache.add(this.filePath, mesh);
            this.VRObject = mesh;
            this.scene.add(mesh);

            this.loader = false;
          }
          reader.readAsArrayBuffer(threeDFileFromUpload);
        }
        else {
          loader.load(`assets/${this.filePath}`, (geometry) => {

            THREE.Cache.clear();
            THREE.Cache.add(this.filePath, geometry);

            let material = new THREE.MeshStandardMaterial();
            let mesh = new THREE.Mesh(geometry, material);

            this.setModelPosition(mesh);
            this.VRObject = mesh;
            this.scene.add(mesh);
            this.loader = false;
          }, (process) => {
            this.uploadPercentDone = Math.round((process.loaded / process.total * 100));
            if (this.uploadPercentDone >= 95) {
              this.uploadText = "Rendering"
            }
            console.log(this.uploadPercentDone + '% loaded');
          }, (err) => {
            console.error(err);
            this.loader = false;
          });
        }
      }
      else {
        this.setModelPosition(threeDObj);
        this.VRObject = threeDObj;
        this.scene.add(threeDObj);
      }
    } else if (format.toLocaleLowerCase() === 'gltf') {
      let threeDObj = THREE.Cache.get(this.filePath);
      var path = this.filePath.split("\\").slice(0, this.filePath.split("\\").length - 1).join('\\');

      const loader = new GLTFLoader();
      this.loader = true;
      directoryArray.splice(directoryArray.length - 1, 1);
      loader.setPath(`assets\\${directoryArray.join('\\')}\\`);
      if (!threeDObj) {

        if (this.httpService.previewDuringUpload) {

          try {
            let threeDFileFromUpload = this.uploadedFiles[0];
            let reader = new FileReader();
            reader.onload = () => {
              // this 'text' is the content of the file

              var text = reader.result;
              console.log("File Read");
              try {
                loader.parse(text, path, (threedObject) => {
                  
                  this.mixer = new THREE.AnimationMixer(threedObject.scene);
                  const clips = threedObject.animations;

                  clips.forEach(clip => {
                    this.mixer.clipAction(clip.optimize() as any).play();
                  });

                  this.setModelPosition(threedObject.scene);
                  this.VRObject = threedObject.scene;
                  this.scene.add(threedObject.scene);
                  this.loader = false;
                });

              } catch (exception) {
                console.log(exception);
                alert("Unable to preview the asset");
              }
            }
            reader.readAsArrayBuffer(threeDFileFromUpload);
          } catch (err) {
            this.loader = false;
          }
        }
        else {
          loader.load(
            `${fileName.split('.')[0]}.gltf`,
            (object) => {
              // called when the resource is loaded
              this.mixer = new THREE.AnimationMixer(object.scene);
              const clips = object.animations;

              clips.forEach(clip => {
                console.log(clip);
                this.mixer.clipAction(clip.optimize() as any).play();
              });
              this.setModelPosition(object.scene);
              this.VRObject = object.scene;
              this.scene.add(object.scene);
              this.loader = false;
            },
            (process) => {
              // called while loading is progressing
              this.uploadPercentDone = Math.round((process.loaded / process.total * 100));
              if (this.uploadPercentDone >= 95) {
                this.uploadText = "Rendering"
              }
              console.log(this.uploadPercentDone + '% loaded');
            },
            (error) => {
              // called when loading has errors
              console.error('An error happened', error);
              this.loader = false;
            },
          );
        }
      }
      else {
        this.VRObject = threeDObj;
        this.scene.add(threeDObj);
      }


    }



    else if (format.toLocaleLowerCase() === 'glb') {
      let threeDObj = THREE.Cache.get(this.filePath);
      var path = this.filePath.split("\\").slice(0, this.filePath.split("\\").length - 1).join('\\');
      const loader = new GLTFLoader();
      this.loader = true;
      directoryArray.splice(directoryArray.length - 1, 1);
      loader.setPath(`assets\\${directoryArray.join('\\')}\\`);
      if (!threeDObj) {


        if (this.httpService.previewDuringUpload) {

          try {
            let threeDFileFromUpload = this.uploadedFiles[0];
            let reader = new FileReader();
            reader.onload = () => {
              // this 'text' is the content of the file

              var text = reader.result;
              console.log("File Read");
              try {
                loader.parse(text, path, (threedObject) => {

                  this.mixer = new THREE.AnimationMixer(threedObject.scene);
                  const clips = threedObject.animations;

                  clips.forEach(clip => {
                    this.mixer.clipAction(clip.optimize() as any).play();
                  });
                  this.setModelPosition(threedObject.scene);
                  this.VRObject = threedObject.scene;
                  this.scene.add(threedObject.scene);
                  this.loader = false;
                });

              } catch (exception) {
                console.log(exception);
                alert("Unable to preview the asset");
              }
            }
            reader.readAsArrayBuffer(threeDFileFromUpload);
          } catch (err) {
            this.loader = false;
          }
        }


        else {
          loader.load(
            `${fileName.split('.')[0]}.glb`,
            (object) => {
              // called when the resource is loaded

              this.mixer = new THREE.AnimationMixer(object.scene);
              const clips = object.animations;

              clips.forEach(clip => {
                this.mixer.clipAction(clip.optimize()).play();
              });
              this.setModelPosition(object.scene);
              this.VRObject = object.scene;
              this.scene.add(object.scene);
              this.loader = false;
            },
            (process) => {
              // called while loading is progressing
              this.uploadPercentDone = Math.round((process.loaded / process.total * 100));
              if (this.uploadPercentDone >= 95) {
                this.uploadText = "Rendering"
              }
              console.log(this.uploadPercentDone + '% loaded');
            },
            (error) => {
              // called when loading has errors
              console.error('An error happened', error);
              this.loader = false;
            },
          );
        }
      }
      else {
        this.VRObject = threeDObj;
        this.scene.add(threeDObj);
      }


    }


    document.addEventListener('webkitfullscreenchange', () => {
      console.log("coco 1");
      if (this.fullScreen && this.fullScreenModeCount === 1) {
        this.camera.aspect = window.innerWidth / (window.innerHeight - 300);
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth - 10, window.innerHeight - 300);
        this.fullScreen = false;
        this.fullScreenModeCount = 0;
      }
      this.fullScreenModeCount = 1;
    }, false);

    document.addEventListener('mozfullscreenchange', () => {
      console.log("coco 2");
      if (this.fullScreen && this.fullScreenModeCount === 1) {
        this.camera.aspect = window.innerWidth / (window.innerHeight - 300);
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth - 40, window.innerHeight - 300);
        this.fullScreen = false;
        this.fullScreenModeCount = 0;
      }
      this.fullScreenModeCount = 1;
    }, false);

    document.addEventListener('fullscreenchange', () => {
      if (this.fullScreen) {
        console.log("coco 3");
        this.camera.aspect = window.innerWidth / (window.innerHeight);
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight)
        this.fullScreen = false;
      }
      console.log("Full screen");
      // if (!this.fullScreen && this.fullScreenModeCount === 1) {
      //   console.log("coco 3");
      //   // this.camera.aspect = window.innerWidth / (window.innerHeight - 300);
      //   // this.camera.updateProjectionMatrix();
      //   // this.renderer.setSize(window.innerWidth - 40, window.innerHeight - 300);
      //   this.fullScreen = true;
      //   this.fullScreenModeCount = 0;
      // }
      // else if (this.fullScreenModeCount == 0) {
      //   this.fullScreenModeCount = 1;
      //   this.fullScreen = false;
      // } else if (this.fullScreenModeCount == 1) {
      //   this.fullScreenModeCount = 0;
      // }
    }, false);

    document.addEventListener('MSFullscreenChange', () => {
      console.log("coco 4");
      if (this.fullScreen && this.fullScreenModeCount === 1) {
        this.camera.aspect = this.width / (this.height - 300);
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.width, this.height - 300);
        this.fullScreen = false;
        this.fullScreenModeCount = 0;
      }
      if (this.fullScreenModeCount == 0) {
        this.fullScreenModeCount = 1;
      } else if (this.fullScreenModeCount == 1) {
        this.fullScreenModeCount = 0;
      }
    }, false);

    // window.addEventListener('resize', () => {
    //   if (this.fullScreen) {
    //     let elem = document.querySelector("canvas");
    //     let sceneWidth = window.innerWidth;
    //     let sceneHeight = elem.offsetHeight;
    //     this.camera.aspect = sceneWidth / sceneHeight;
    //     this.camera.updateProjectionMatrix();
    //     this.renderer.setSize(sceneWidth, sceneHeight);
    //     // this.fullScreenModeCount = 0;
    //   } else {
    //     this.camera.aspect = window.innerWidth / (window.innerHeight - 300);
    //     this.camera.updateProjectionMatrix();
    //     this.renderer.setSize(window.innerWidth - 40, window.innerHeight - 300);
    //   }
    // }, false);
  }

  onResize(size) {

    if (!this.fullScreen) {
      console.log("coco", size, this.fullScreenModeCount, this.fullScreen)
      let elem = document.querySelector("canvas");
      let sceneWidth = size.width - 40;
      let sceneHeight = size.height - 300;
      this.camera.aspect = sceneWidth / sceneHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(sceneWidth, sceneHeight);
      // this.fullScreenModeCount = 0;
    } else {
      this.camera.aspect = window.innerWidth / (window.innerHeight);
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight)
    }
  }

  changeBackround(color) {
    this.seenBackGround = color;
  }

  takeSnap(): string {
    let imgData = this.renderer.domElement.toDataURL();
    return imgData;
  }
  getUniqueMaterials(materialArray: any) {
    let returnMaterials = [];
    materialArray.forEach(material => {
      if ((returnMaterials.filter(x => x == material).length == 0)) {
        material.side = THREE.DoubleSide;
        returnMaterials.push(material);
      }
    });
    return returnMaterials.length == 1 ? returnMaterials[0] : materialArray;
  }

  setModelPosition(threeDObj) {
    threeDObj.position.set(0,0,0);
    var desiredScale = 200;
    var scaleV3 = new THREE.Vector3().setScalar(desiredScale);
    var box = new THREE.Box3();
    box.setFromObject(threeDObj);

    var size = new THREE.Vector3();
    box.getSize(size);

    var center = new THREE.Vector3();
    box.getCenter(center);

    var scaleTemp = new THREE.Vector3().copy(scaleV3).divide(size);
    var scale = Math.min(scaleTemp.x, Math.min(scaleTemp.y, scaleTemp.z));
    threeDObj.scale.setScalar(scale);

    threeDObj.position.sub(center.multiplyScalar(scale));

  }

  applyDoubleSideProperty(childArr) {
    if (childArr instanceof Mesh) {
      let threedMesh = childArr as Mesh;
      if (threedMesh.material instanceof Material) {
        if (threedMesh.material.side == 0)
          threedMesh.material.side = THREE.DoubleSide;
      }
      else {
        let threedMaterial = threedMesh.material as Material[];
        for (var j = 0; j < threedMaterial.length; j++) {
          if (threedMaterial[j].side == 0)
            threedMaterial[j].side = THREE.DoubleSide;
        }
      }
    }

    for (var i = 0; i < childArr.children.length; i++) {
      var child = childArr.children[i];
      if (child instanceof Mesh) {
        let threedMesh = child as Mesh;
        if (threedMesh.material instanceof Material) {
          if (threedMesh.material.side == 0)
            threedMesh.material.side = THREE.DoubleSide;
        }
        else {
          let threedMaterial = threedMesh.material as Material[];
          for (var j = 0; j < threedMaterial.length; j++) {
            if (threedMaterial[j].side == 0)
              threedMaterial[j].side = THREE.DoubleSide;
          }
        }
      }
      else if (child instanceof Group) {
        this.applyDoubleSideProperty(child);
      }
    }
  }


  ngOnDestroy()
  {
    this.renderer.dispose();
  }
}
